module.exports = __webpack_public_path__ + "media/images/eye-dc20c4a2db5fe9650674f56bf12cae54.svg";